export class buyingPowerSummaryModel {
cstmInvestorID : any;
setValue(res){
if(res){
if(res['cstmInvestorID']){this.cstmInvestorID = res['cstmInvestorID'];}
}
}
}